import React from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { GENERATE_CANDIDATES_LABEL } from '../GenerateExpression.constants';
import { candidatesGridStyles, modalSectionLabelStyles } from '../GenerateExpression.styles';
import { GenerateExpressionTestIds } from '../GenerateExpression.testIds';

import CandidateCard from './CandidateCard';

const CandidatesGrid = ({
  candidates,
  isNewExpressionsParsingLogicEnabled,
  onSelect,
  schemaDomain,
  schemaJson = null,
}) => (
  <Box data-testid={GenerateExpressionTestIds.MODAL_CANDIDATES_GRID}>
    <Typography color="text.secondary" sx={modalSectionLabelStyles} variant="bold12">
      {GENERATE_CANDIDATES_LABEL}
    </Typography>
    <Box sx={candidatesGridStyles}>
      {candidates.map((candidate, index) => (
        <CandidateCard
          candidate={candidate}
          index={index}
          isNewExpressionsParsingLogicEnabled={isNewExpressionsParsingLogicEnabled}
          key={candidate?.aiUsageMetricsId ?? `candidate-${index}`}
          schemaDomain={schemaDomain}
          schemaJson={schemaJson}
          onSelect={onSelect}
        />
      ))}
    </Box>
  </Box>
);

CandidatesGrid.propTypes = {
  candidates: PropTypes.arrayOf(
    PropTypes.shape({
      expressionJson: PropTypes.string,
      summary: PropTypes.string,
      assumptions: PropTypes.arrayOf(PropTypes.string),
      aiUsageMetricsId: PropTypes.string,
      confidence: PropTypes.number,
    }),
  ).isRequired,
  isNewExpressionsParsingLogicEnabled: PropTypes.bool.isRequired,
  schemaDomain: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  schemaJson: PropTypes.string,
};

export default CandidatesGrid;
